var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 11.2C28.5333 12.8192 28.5333 19.1691 26.4 20.8",
    stroke: "#E8F2FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1756 6.4758L10.4 11.2777V20.7221L20.1756 25.524C20.3332 25.5877 20.5042 25.6119 20.6735 25.5944C20.8428 25.5769 21.0051 25.5182 21.146 25.4237C21.2869 25.3291 21.4021 25.2016 21.4813 25.0523C21.5605 24.9031 21.6012 24.7368 21.6 24.5682V7.43163C21.6012 7.26303 21.5605 7.09673 21.4813 6.94749C21.4021 6.79825 21.2869 6.67069 21.146 6.57613C21.0051 6.48157 20.8428 6.42294 20.6735 6.40544C20.5042 6.38793 20.3332 6.4121 20.1756 6.4758Z",
    stroke: "#E8F2FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 11.2H6.74286C6.01541 11.2 5.31775 11.4961 4.80336 12.0232C4.28898 12.5502 4 13.2651 4 14.0106V17.9894C4 18.7348 4.28898 19.4497 4.80336 19.9767C5.31775 20.5038 6.01541 20.8 6.74286 20.8H10.4",
    stroke: "#E8F2FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.5452cd2995db7bb96440f3fc85b030de.svg";
export { ForwardRef as ReactComponent };